import { useTranslation } from 'react-i18next';

const LOGO_WIDTH = 324;
const LOGO_HEIGHT = 80;

/** The Social Studio logo with the "Admin" tag, so nobody mistakes the console for the customer app. */
export function BrandMark() {
  const { t } = useTranslation();
  return (
    <span className="ui-brand ui-console-brand">
      <img className="ui-brand__logo" src="/brand/social-studio-logo.png" alt={t('brand.name')} width={LOGO_WIDTH} height={LOGO_HEIGHT} decoding="async" />
      <span className="ui-console-brand__tag">{t('brand.console')}</span>
    </span>
  );
}
